var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MovePackingConditionsRadioField',_vm._g({attrs:{"choices":_vm.choices}},_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }